import { render } from "./SamplesManualsPage.vue?vue&type=template&id=55f1bcf2&scoped=true"
import script from "./SamplesManualsPage.vue?vue&type=script&lang=js"
export * from "./SamplesManualsPage.vue?vue&type=script&lang=js"

import "./SamplesManualsPage.vue?vue&type=style&index=0&id=55f1bcf2&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f1bcf2"]])

export default __exports__